import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  set: {
    width: 100,
    height: 100,
    paths: [
      {
        style: `fill: #eb212e`,
        d: `M97.41,87.69v3.4a.8.8,0,0,1-.8.8H3.5a.8.8,0,0,1-.8-.8v-3.4a.8.8,0,0,1,.8-.8H4V48.28H27.87a26.78,26.78,0,0,0,20.69,
        12.3v4.86H22.41V49.81a.8.8,0,0,0-.8-.8h-1.4a.8.8,0,0,0-.8.8V65.44H8.76a.81.81,0,0,0-.81.81v1.39a.8.8,
        0,0,0,.81.8H19.41V84.08a.8.8,0,0,0,.8.8h1.4a.8.8,0,0,0,.8-.8V68.44H48.56V84.08a.8.8,0,0,0,.8.8h1.39a.8.8,0,0,0,
        .81-.8V68.44H77.49V84.08a.8.8,0,0,0,.81.8h1.39a.8.8,0,0,0,.8-.8V68.44H90.93a.8.8,0,0,0,
        .81-.8V66.25a.81.81,0,0,0-.81-.81H80.49V49.81a.8.8,0,0,0-.8-.8H78.3a.8.8,0,0,0-.81.8V65.44H51.56V60.62A26.72,26.72,
        0,0,0,73,48.28H95.73V86.89h.88A.8.8,0,0,1,97.41,87.69Z`,
      },
      {
        style: `fill: #4d4d4d`,
        d: `M27.86,48.28H3.51a.81.81,0,0,1-.81-.81V44.08a.8.8,
          0,0,1,.81-.8H25.35A26.89,26.89,0,0,0,27.86,48.28Zm68.75-5H75.49a27.52,27.52,0,0,1-2.51,5H96.61a.8.8,
          0,0,0,.8-.81V44.08A.8.8,0,0,0,96.61,43.28Z`,
      },
      {
        style: `fill: #4d4d4d`,
        d: `M50.42,10.1A23.78,23.78,0,1,0,74.2,33.88,23.78,23.78,0,0,0,50.42,10.1ZM63.67,34.78a.8.8,
          0,0,1-.8.8H52.12V46.33a.8.8,0,0,1-.8.8h-1.8a.8.8,0,0,1-.8-.8V35.58H38a.79.79,0,0,1-.79-.8V33a.79.79,
          0,0,1,.79-.79H48.72V21.42a.79.79,0,0,1,.8-.79h1.8a.79.79,0,0,1,.8.79V32.18H62.87a.79.79,0,0,1,.8.79Z`,
      },
    ],
  },
});
